import React from "react";
import { Switch, Route } from "react-router-dom";

import "./App.scss";
import "./css/parallax.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Members from "./pages/Members/Members";
import AircraftAdvanced from "./pages/Aircraft/Advanced";
import AircraftAuton from "./pages/Aircraft/Auton";
import AircraftHiLift from "./pages/Aircraft/HiLift";
import AircraftHistory from "./pages/Aircraft/History";
import Sponsors from "./pages/Sponsors/Sponsors";
import Contact from "./pages/Contact/Contact";
import Design from "./pages/Design/Design";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <div className="Page">
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/members" component={Members} />
          <Route exact path="/aircraft" component={AircraftHistory} />
          <Route exact path="/aircraft/hi-lift" component={AircraftHiLift} />
          <Route exact path="/aircraft/advanced" component={AircraftAdvanced} />
          <Route exact path="/aircraft/auton" component={AircraftAuton} />
          <Route exact path="/aircraft/history" component={AircraftHistory} />
          <Route exact path="/sponsors" component={Sponsors} />
          <Route exact path="/get-involved" component={Contact} />
          {/* <Route exact path="/design" component={Design} /> */}
          <Route path="*" component={NotFound} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default App;
